"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Box = _interopRequireDefault(require("../Box"));

var _once = _interopRequireDefault(require("./once"));

var _YOffsetter = _interopRequireDefault(require("./YOffsetter"));

var _Fader = _interopRequireDefault(require("./Fader"));

var _ToastCard = _interopRequireDefault(require("./ToastCard"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var toastIdCounter = 0;
var exposedRef = {};
var SPACE_BETWEEN = 16;
var DEFAULT_TIMEOUT = 5000;

var _StyledBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "ToastContainer___StyledBox",
  componentId: "gsqy6r-0"
})(["position:fixed;top:0;right:20px;z-index:999;"]);

var ToastContainer = function ToastContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;

  var _useToasts = useToasts({
    offset: offset
  }),
      toasts = _useToasts.toasts;

  return toasts.map(function (_ref2) {
    var visible = _ref2.visible,
        yOffset = _ref2.yOffset,
        onFade = _ref2.onFade,
        t = _objectWithoutProperties(_ref2, ["visible", "yOffset", "onFade"]);

    return _react["default"].createElement(_StyledBox, {
      key: t.id,
      minWidth: 300
    }, _react["default"].createElement(_YOffsetter["default"], {
      yOffset: yOffset
    }, _react["default"].createElement(_Fader["default"], {
      visible: visible,
      onFade: onFade
    }, _react["default"].createElement(_ToastCard["default"], t))));
  });
};

ToastContainer.propTypes = {
  offset: _propTypes.number
};
var _default = ToastContainer;
exports["default"] = _default;
var toast = {
  neutral: function neutral(opts) {
    return exposedRef.addToast('neutral', opts);
  },
  info: function info(opts) {
    return exposedRef.addToast('info', opts);
  },
  error: function error(opts) {
    return exposedRef.addToast('error', opts);
  }
};
exports.toast = toast;

var useToasts = function useToasts(_ref3) {
  var offset = _ref3.offset;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1];

  var toastsRef = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    exposedRef.addToast = function (variant, opts) {
      var toastId = toastIdCounter++; // Begins the animation (to full opacity and correct position),
      // the soonest the ref is accessed

      var beginAnimationRef = function beginAnimationRef(toastEl) {
        if (!toastEl) return;
        toastsRef.current[toastId] = toastEl;
        setToasts(updateById(function (t) {
          return _objectSpread({}, t, {
            elementHeight: toastEl.offsetHeight,
            visible: true
          });
        }, toastId));
      }; // Initiates fading animation


      var handleClose = (0, _once["default"])(function () {
        return setToasts(updateById(function (t) {
          return _objectSpread({}, t, {
            visible: false
          });
        }, toastId));
      }); // Triggers after fading animation, finally removes the subject toast

      var handleFade = function handleFade() {
        return setToasts(function (ts) {
          return ts.filter(function (t) {
            return t.id !== toastId;
          });
        });
      }; // Adds the toast, in its transparent, and offset to the top style


      setToasts(function (ts) {
        return [_objectSpread({
          variant: variant,
          id: toastId,
          timeout: DEFAULT_TIMEOUT,
          visible: false,
          ref: beginAnimationRef,
          onClose: handleClose,
          onFade: handleFade
        }, opts)].concat(_toConsumableArray(ts));
      });
      return handleClose;
    };
  }, []);
  var finalToasts = toasts.map(function (t, i) {
    return (// calculate y offset
      _objectSpread({}, t, {
        yOffset: !t.elementHeight ? 0 : offset + toasts.slice(0, i).filter(function (t) {
          return t.elementHeight;
        }).map(function (t) {
          return t.elementHeight + SPACE_BETWEEN;
        }).reduce(add, 0)
      })
    );
  }).map(function (_ref4) {
    var elementHeight = _ref4.elementHeight,
        t = _objectWithoutProperties(_ref4, ["elementHeight"]);

    return t;
  }); // remove unnecessary prop

  return {
    toasts: finalToasts
  };
};

var add = function add(a, b) {
  return a + b;
};

var updateById = function updateById(updater, id) {
  return function (xs) {
    return xs.map(function (x) {
      return x.id === id ? updater(x) : x;
    });
  };
};